import type { AddParticipantApiResponse, GroupStatus, GroupStatusApiResponse } from '@/domain/groups/types'
import {
  createQueryStringSerializer,
  type QueryStringSerializer,
} from '@/scopes/common/infrastructure/query-strings/queryStringSerializer'
import defaultFetch from 'isomorphic-unfetch'
import { createGroupsMapper, type GroupMapper } from './groupMapper'

interface Dependencies {
  env: {
    NEXT_PUBLIC_API_BASE_URL: string
    NEXT_PUBLIC_API_URL: string
  }
  fetch: typeof defaultFetch
  queryStringSerializer: QueryStringSerializer
  groupMapper: GroupMapper
}

export function createGroupBookingsAPIClient(dependencies: Partial<Dependencies> = {}) {
  const {
    env = {
      NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
      NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
    },
    fetch = defaultFetch,
    queryStringSerializer = createQueryStringSerializer(),
    groupMapper = createGroupsMapper(),
  } = dependencies as Dependencies

  async function getGroupStatus(masterBookingNumber: string): Promise<GroupStatus> {
    const response = await fetch(
      `${env.NEXT_PUBLIC_API_BASE_URL}/GroupBookingsApi/GetGroupBookingStatus/?masterBookingNumber=${masterBookingNumber}`,
    )
    const data: GroupStatusApiResponse = await response.json()

    return groupMapper.map(data)
  }

  async function subscribeParticipant(sid: string): Promise<GroupStatus> {
    const queryString = queryStringSerializer.serialize({
      sid,
      stepTimeout: '30000',
    })

    const response = await fetch(`${env.NEXT_PUBLIC_API_URL}/GroupBookingsApi/SubscribeParticipant?${queryString}`, {
      method: 'PATCH',
      body: null,
    })

    const data: AddParticipantApiResponse = await response.json()

    return groupMapper.mapAddParticipant(data)
  }

  return {
    getGroupStatus,
    subscribeParticipant,
  }
}
